/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseclasses/guid.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MembershipManager {
    import ClientMembershipStatusEnum = Meevo.Model.ClientMembershipStatusEnum;
    export function membershipNameFilter() {
       return (input: Model.ClientMembership): string => {

            if (!input) {
                return "";
            }
            let status;

            switch (input.clientMembershipStatusEnum) {
                case ClientMembershipStatusEnum.Active:
                    status = 'Active';
                    break;
                case ClientMembershipStatusEnum.Cancelled:
                    status = 'Cancelled';
                    break;
                case ClientMembershipStatusEnum.Expired:
                    status = 'Expired';
                    break;
                case ClientMembershipStatusEnum.InActive:
                    status = 'In Active';
                    break;
                default:
                    status = '';
            }

            return `${input.membershipDisplayName} - ${status}`;
        };
    }


    angular.module("meevo.plugins.membershipManager")
        .filter("meevoMembershipNameFilter", membershipNameFilter);
}
